import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Shield } from "lucide-react";
import SessionList from "@/components/sessions/SessionList";

interface Session {
  id: string;
  created_at: string;
  expires_at: string;
  user_agent: string | null;
  session_token: string | null;
}

const ProfielSessies = () => {
  const { user } = useAuth();
  const [sessions, setSessions] = useState<Session[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentSessionToken, setCurrentSessionToken] = useState<string | null>(null);

  const loadSessions = async () => {
    if (!user) return;

    try {
      const { data, error } = await supabase
        .from('auth_sessions')
        .select('id, created_at, expires_at, user_agent, session_token')
        .eq('medewerker_id', user.id)
        .eq('is_active', true)
        .order('created_at', { ascending: false });

      if (error) throw error;

      setSessions(data || []);
    } catch (error) {
      console.error('Error loading sessions:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Get current session token from localStorage
    const token = localStorage.getItem('auth_session_token');
    setCurrentSessionToken(token);
    
    loadSessions();
  }, [user]);

  return (
    <div className="container max-w-4xl py-8 space-y-6">
      <div className="flex items-center gap-3">
        <Shield className="w-8 h-8 text-primary" />
        <div>
          <h1 className="text-3xl font-bold">Actieve Sessies</h1>
          <p className="text-muted-foreground">
            Beheer uw actieve inlog sessies en log uit op apparaten
          </p>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
        </div>
      ) : (
        <SessionList 
          sessions={sessions}
          currentSessionToken={currentSessionToken}
          onSessionRemoved={loadSessions}
        />
      )}
    </div>
  );
};

export default ProfielSessies;
